import { isBrowser } from "./common"

export const storage = {
  load<T=any>(key:string):T|null {
    const valueString = window.localStorage.getItem(key)
    if (valueString===null||valueString===undefined||valueString==='') {
      return null
    } else {
      return JSON.parse(valueString)
    }
  },

  store (key:string, value:any) {
    isBrowser() && window.localStorage.setItem(key, JSON.stringify(value))
  },

  discard (key:string) {
    isBrowser() && window.localStorage.removeItem(key)
  }
}

export const sessionStorage = {
  load<T=any>(key:string):T|null {
    if (isBrowser()) {
      const valueString = window.sessionStorage.getItem(key)
      if (valueString===null||valueString===undefined||valueString==='') {
        return null
      } else {
        return JSON.parse(valueString)
      }
    }
    return null
  },

  store (key:string, value:any) {
    isBrowser() && window.sessionStorage.setItem(key, JSON.stringify(value))
  },

  discard (key:string) {
    isBrowser() && window.sessionStorage.removeItem(key)
  }
}
